import { HelpLink, HelpSection } from "@omnia/shared/shell"
import { OmniaModuleId } from "../../shared/generated/enums"


export function getOmniaHelpLinks(): Record<HelpSection, HelpLink[]> {

    return {

        [OmniaModuleId.Dashboard]: [
            {
                title: 'Quick start guide',
                link: '/help/dashboard/Quick%20start%20guide.pdf'
            },
            {
                title: 'Getting Started - The Complete Guide',
                link: 'RtMT2nyKtps'
            },
            {
                title: 'England & Wales NVZ Guidance',
                link: '/help/dashboard/England%20&%20Wales%20NVZ%20Guidance.pdf'
            },
            {
                title: 'Basic Navigation of (@brand)',
                link: 'KCT_sdCkrCo'
            },
            {
                title: 'Create a New Holding',
                link: 'krVbopkYIKA'
            },
            {
                title: 'Editing a Holding',
                link: 'aCKRIn-gv9w'
            },
            {
                title: 'Connecting (@brand) to Dropbox',
                link: 'LU8qPaODTws'
            },
            {
                title: 'Connecting (@brand) to MyJohnDeere',
                link: 'dLKncu2Bk_Q'
            },
            {
                title: 'Connecting (@brand) to CLAAS TELEMATICS',
                link: 'lavnSXKjqas'
            },
            {
                title: 'Connecting (@brand) to GLGM',
                link: 'XK8anxlE2LE'
            },
            {
                title: 'Managing farm data',
                link: '1dNMtgxoCbE'
            },
            {
                title: 'Multiple users',
                link: '3WU--e7cxEk'
            },
            {
                title: 'User Creation and Permissions',
                link: '5mmZarYpEnE',
                id: "holdingPermissions"
            },
        ],

        [OmniaModuleId.Layers]: [
            {
                title: 'Map Layers Overview',
                link: '49UY_kMAJg8'
            },
            {
                title: 'Creating map layers',
                link: 'epq0nUqFk3c'
            },
            {
                title: 'Editing a Layer',
                link: '8716PeuRMok'
            },
            {
                title: 'Importing Layers from a Shape File',
                link: 'X3jixEEDLTs'
            },
            {
                title: 'Generic drawing layers',
                link: 'TrnMlygVZOI'
            },
            {
                title: 'Holding layers',
                link: 's1ZB3S3JZv8'
            },
            {
                title: 'Picture layers',
                link: 'YI01KR89fTk'
            },
            {
                title: 'TerraMap texture interpretation webinar recording',
                link: 'L6997cSuKr8'
            },
            {
                title: "Creating NDVI Map Layers",
                link: "UCpsRs2dLDY"
            }
        ],

        [OmniaModuleId.Exports]: [
            {
                title: 'Export module overview',
                link: 'OT1o_JUyoIE'
            },
            {
                title: 'Export (@brand) data into an new GLGM site',
                link: 'vR2Ad7WtYEc'
            },
            {
                title: 'GLGM sync – Export data',
                link: '-Z_lmNrpqp8'
            }
        ],

        [OmniaModuleId.Fields]: [
            {
                title: 'Fields module overview',
                link: '5g38h6objfA'
            },
            {
                title: 'Creating a Field',
                link: 'g6PwZd1nIG0'
            },
            {
                title: 'Field Editing',
                link: '9EVNStws9zY'
            },
            {
                title: 'Adding and Editing Cropping',
                link: 'uPLvUVKQBho'
            },
            {
                title: 'Editing Crop Colours',
                link: 'Mgf7c5UqnuQ'
            },
            {
                title: 'Destroying a Crop',
                link: 'g10px-bp_DU'
            },
            {
                title: 'Setting up a New Crop Year',
                link: '5lClED-FKxY'
            },
            {
                title: 'Using Filters',
                link: 'HF7xXsHjnFU'
            },
            {
                title: 'Map Tools',
                link: 'hXXESafeR8o'
            },
            {
                title: 'Importing field and crop information from GateKeeper',
                link: 'EqCXUSInM_I'
            },
            {
                title: 'Importing Field Boundaries',
                link: 'laSp1exdAZ0'
            },
            {
                title: 'Importing a field boundary using a machine spreading file',
                link: '1rmxH4QSj2w'
            },
            {
                title: 'Managing grass and other perennial crops',
                link: 'HkeWUhFUack'
            },
            {
                title: "Adding SFI management options",
                link: "nQpJSHJ0Y1o"
            }
        ],

        [OmniaModuleId.Imports]: [
            {
                title: 'Importing field and crop information from GateKeeper',
                link: 'EqCXUSInM_I'
            },
            {
                title: 'Importing soil analysis from a lab file',
                link: 'yadWdJoOtuE'
            },
            {
                title: 'Importing a field boundary from a shape file',
                link: 'laSp1exdAZ0'
            },
            {
                title: 'Importing a field boundary using a machine spreading file',
                link: '1rmxH4QSj2w'
            },
            {
                title: 'Connecting (@brand) to Dropbox',
                link: 'vRKEagaP80M'
            },
            {
                title: 'Connecting (@brand) to MyJohnDeere',
                link: 'dLKncu2Bk_Q'
            },
            {
                title: 'Managing farm data',
                link: '1dNMtgxoCbE'
            },
            {
                title: 'Importing pictures',
                link: '5EL3Nju2d8A'
            },
            {
                title: 'Exporting cropping from GateKeeper',
                link: 'IiBrXq4mTOM'
            },
            {
                title: 'Exporting yield maps from CLAAS Telematics',
                link: 'bt8O6nkqrkQ'
            },
            {
                title: 'Preparing Case & New Holland yield maps for importing',
                link: 'k5b3jO3SyA0'
            },
            {
                title: 'Importing yield maps',
                link: 'IrkbRRU8pCM'
            },
            {
                title: 'Connecting (@brand) to CLAAS TELEMATICS',
                link: 'lavnSXKjqas'
            },
            {
                title: 'Importing boundaries from CLAAS TELEMATICS',
                link: 'VxMeFwIHzLo'
            },
            {
                title: 'Importing yield maps from CLAAS TELEMATICS',
                link: '-tV6pn88gio'
            },
            {
                title: 'Connecting (@brand) to GLGM',
                link: 'XK8anxlE2LE'
            },
            {
                title: 'Import GLGM data into a new (@brand) Holding',
                link: '4CbbUw3Pmms'
            },
            {
                title: 'GLGM sync – Existing data in both systems - Fields',
                link: 'FAfTDeRddtg'
            },
            {
                title: 'GLGM sync – Existing data in both systems - Cropping',
                link: '0x16FG865vo'
            }
        ],

        [OmniaModuleId.Nutrition]: [
            { title: 'Nutrition module overview', link: 'kaJOSVJbUq8' },
            { title: 'Calculating requirements', link: '4Hbyefn_Poo' },
            { title: 'Understanding & editing requirements', link: 'fZ6AvRqcwKM' },
            { title: 'Creating plans', link: 'lkigUgu9dSM' },
            { title: 'Creating precision plans', link: 'TaN4zJ76Slk' },
            { title: 'Creating lime plans', link: '9f5X4XeSems' },
            { title: "Nitrogen breakeven adjustment", link: "fVbG-dOfArk" }
        ],


        nutrition: [
            { title: 'Nutrition 2.0 Requirements', link: 'nrII62DhjP4' },
            { title: 'Nutrition 2.0 Plans', link: 'F2GbJxylNPo' },
            { title: 'Nutrition 2.0 Precision Plans', link: 'pBGeoxKm9x8' },
            { title: 'Nutrition 2.0 Rulesets', link: '8ZLcgftpqII' },
            { title: 'Nutrition 2.0 VR N Plans', link: 'WNP7NXvovBw' }
        ],


        [OmniaModuleId.Seeds]: [
            { title: 'Creating a seed plan', link: 'fGaxMqwlj50' },
            { title: 'Creating manual seed plans', link: 'WG3_udSsfN4' },
            { title: 'Editing seed plans', link: 'uJtbpay1Uxc' },
        ],

        [OmniaModuleId.Reports]: [
            {
                title: 'Creating Reports',
                link: '5Iit57LN0Rc'
            },
            {
                title: 'Managing Reports',
                link: '6HIndrh0Aas'
            },
            {
                title: 'Managing map regions',
                link: 'B4yoxW4WRno'
            },
            {
                title: 'Field Diary Reporting',
                link: 'INoY4-tVzmQ'
            }
        ],

        [OmniaModuleId.Reports2]: [
            {
                title: 'Creating Reports',
                link: '5Iit57LN0Rc'
            },
            {
                title: 'Managing Reports',
                link: '6HIndrh0Aas'
            },
            {
                title: 'Managing map regions',
                link: 'B4yoxW4WRno'
            },
            {
                title: 'Field Diary Reporting',
                link: 'INoY4-tVzmQ'
            }
        ],

        [OmniaModuleId.Soil]: [
            {
                title: 'Managing soil analysis',
                link: 'FAfh6_fj-zs'
            },
            {
                title: 'Creating a new soil analysis',
                link: 'BGsIzIGQsW0'
            },
            {
                title: 'Importing soil analysis from a lab file',
                link: 'yadWdJoOtuE'
            },
            {
                title: 'Creating Soil Management Plans',
                link: 'AXjYsJBMs8g'
            }
        ],

        [OmniaModuleId.Stocks]: [
            {
                title: 'Stocks - Getting Started',
                link: 'VXgODl7ZmzY'
            },
            {
                title: 'Stocks - Multiple Locations',
                link: 'DCY3OtR2QTo'
            },
            {
                title: 'Stocks - Orders, Pricing & Suppliers',
                link: '5uzfXjPe_Ko'
            },
            {
                title: "Stock Management and Reconciliation",
                link: "BfdsScjE7QY"
            },
            {
                title: "Stock Management - Troubleshooting",
                link: "6wSsz91kQz4"
            },
            {
                title: "Seed Units",
                link: "jVCBl0U6hR8"
            }
        ],

        [OmniaModuleId.Manure]: [
            {
                title: 'Chapter 6 - The farm limit',
                link: '/help/manure/Chapter%206%20-%20The%20farm%20limit.pdf'
            },
            {
                title: 'Chapter 8 - Application of manures',
                link: '/help/manure/Chapter%208%20-%20Application%20of%20manures.pdf'
            },
            {
                title: 'Chapter 10 - Storing manures',
                link: '/help/manure/Chapter%2010%20-%20Storing%20manures.pdf'
            },
            {
                title: 'Annex 4 - Preparing a risk map',
                link: '/help/manure/Annex%204%20-%20Preparing%20a%20risk%20map.pdf'
            },
            {
                title: 'Manure module overview',
                link: 'mPYGABVkx-E'
            },
            {
                title: 'Grassland derogation & temporary grazing',
                link: 'sXsdhonTGSs'
            },
            {
                title: 'Adding livestock',
                link: 'P2lKZbxQWqc'
            },
            {
                title: 'Manage storage requirements  ',
                link: 'pX30my2fKfs'
            },
            {
                title: 'Managing the NVZ risk map',
                link: 'POtMAiPTNUg'
            },
            {
                title: 'Manure stocks, imports & exports',
                link: 'BAvePTQBUzU'
            },
            { 
                title: 'Managing Manure Storage',
                link: 'B7AZ0U-RMsc'
            }
        ],

        [OmniaModuleId.Climate]: [
            {
                title: 'Climate module overview and dashboard',
                link: 'k_lzWgKqCyc'
            },
            {
                title: 'Getting started and managing stations',
                link: 's5tOjgjNlYE'
            },
            {
                title: 'Crop growth models',
                link: 'RNC_qCWZ42I',
                accessRole: false
            },
            {
                title: 'Pest & Disease models',
                link: 'GzrUjlntq6o',
                accessRole: false
            },
        ],

        [OmniaModuleId.FieldDiary]: [
            {
                title: 'Field Diary Overview',
                link: 'Fb2w_iMsRWg'
            },
            {
                title: 'Field Diary - Task Creation',
                link: 'CIRZd-QP36Y'
            },
            {
                title: 'Field Diary - Task Completion',
                link: 'EiNVrZf2vw4'
            },
            {
                title: 'Scout App - Field Diary',
                link: 'RQ45yNvGAKs'
            },
            {
                title: 'Scout App - Managing Holdings',
                link: 'iyILYZua0Tc'
            },
            {
                title: 'Scout App - Map Layers',
                link: '1OM8LCHCvog'
            },
            {
                title: 'Scout App - Task Management',
                link: 'Ln_HcwUVdJI'
            },
            {
                title: 'Scout App - Stocks',
                link: 'hhBHsCK4HMg'
            },
            {
                title: 'Understanding VESS Score',
                link: '/help/soil/Understanding%20VESS%20Score.pdf'
            },
        ],

        [OmniaModuleId.CropProtection]: [
            {
                title: 'Creating Plans',
                link: 'Z-ucSZyBzzI'
            },
            {
                title: 'Managing Plans',
                link: 'oEFlojwjnjE'
            },
            {
                title: 'Splitting Plans',
                link: '4f6ezzLhjVU'
            },
            {
                title: 'Spray - Custom Products',
                link: 'cz-f9Mn3L78'
            },
            {
                title: 'Spray - The Audit Process',
                link: 'xanB35foibQ'
            },
            {
                title: 'Spray Plan Templates',
                link: 'FrfxN-SSWnM'
            },
            {
                title: 'Spray Plan Reporting',
                link: 'a-DesO_xLBQ'
            }
        ],

        [OmniaModuleId.Shed]: [
            {
                title: 'The Shed - Operations',
                link: 'LxFcRmzr5o4'
            }
        ],

        [OmniaModuleId.CostOfProduction]: [
            {
                title: 'Production',
                link: 'vbHNV7Kjeu0'
            }
        ]

    } as const

}
